import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { BackendService } from './backend-prod.service';

@Injectable({
  providedIn: 'root'
})
export class FreeTrialAuthService implements CanActivate {

  constructor(
    public storage: Storage,
    private backendService: BackendService, // Replace with your backend service
    private nav: NavController

  ) { }

  async checkShowRegister(): Promise<boolean> {
    try {
      const res = await this.getStorage();
      const data = await this.backendService.GetAPICall('getAllConfig', res.token).toPromise(); // Convert the Observable to a Promise
      const showRegisterConfig = data.find(item => item.id === 1 && item.config_name === 'SHOW_REGISTER');
      if (showRegisterConfig && showRegisterConfig.config_value === '1') {
        return true;
      }
      // Handle the case when the configuration is not found or doesn't match
      return false;
    } catch (error) {
      return false;
    }
  }  

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise(async (resolve) => {
      const isAllowed = await this.checkShowRegister();
      if (isAllowed) {
        resolve(true); // Allow access to the current URL
      } else {
        this.nav.navigateRoot(['login'], { queryParams: { returnUrl: state.url } });
        resolve(false); // Redirect to the login page
      }
    });
  }
}
